
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weekendgatwaycabfrom() {



    const cardData =
    {
        keyword: 'Weekend Getaway Cabs from Pune',
        heading: 'Platinum24 Cabs: Weekend Getaway Cabs from Pune',
        headingDescription: ' Platinum24 Cabs offers comfortable Weekend Getaway Cabs from Pune, making your short trips to nearby hill stations, beaches, and pilgrim spots hassle-free. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and enjoyable ride with spacious seating and air-conditioned comfort. With professional chauffeurs, timely pickups, and flexible packages, we make weekend travel convenient for families, couples, and groups. Whether you’re heading to Lonavala, Mahabaleshwar, Alibag, Shirdi, or Lavasa, Platinum24 Cabs guarantees safe, reliable, and affordable cab services for your perfect weekend escape from Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



 "services": [
    {
      "name": "Weekend Getaway Cab Pune",
      "description": "Plan your perfect weekend escape with our Weekend Getaway Cab service in Pune. Whether you’re heading to nearby hill stations, nature spots, or adventure destinations, our cabs provide comfort, safety, and reliability to make your trip memorable. Ideal for families, friends, and solo travelers, enjoy affordable and hassle-free weekend trips with professional drivers."
    },
    {
      "name": "Pune Weekend Trip Taxi",
      "description": "Book a Pune Weekend Trip Taxi for seamless travel to popular weekend destinations around Pune. Our taxis are equipped with modern amenities to ensure a relaxing ride. Choose from a variety of vehicles to suit your group size and budget."
    },
    {
      "name": "Weekend Tour Cabs Pune",
      "description": "Discover scenic routes and local attractions with our Weekend Tour Cabs in Pune. Perfect for tourists and locals alike, our guided weekend tours offer flexible itineraries and customized packages to make your weekend exciting and stress-free."
    },
    {
      "name": "Affordable Weekend Getaway Taxi Pune",
      "description": "Travel smart and save big with our affordable weekend getaway taxi services in Pune. We offer competitive pricing without compromising on quality, making weekend getaways accessible for everyone."
    },
    {
      "name": "Weekend Trip Taxi Booking Pune",
      "description": "Easily book your weekend trip taxi in Pune online or via phone. Our user-friendly booking process and 24/7 customer support make planning your weekend getaway quick and convenient."
    },
    {
      "name": "Weekend Outstation Cab Pune",
      "description": "Travel outstation effortlessly with our Weekend Outstation Cab services from Pune. Whether it’s a quick hill station visit or a nature retreat, our reliable cabs ensure timely pickups and comfortable rides."
    },
    {
      "name": "Pune Weekend Cab Packages",
      "description": "Choose from a variety of Pune Weekend Cab Packages designed to fit your travel plans and budget. Our customizable packages include options for family trips, adventure tours, and sightseeing."
    },
    {
      "name": "Weekend Family Trip Cab Pune",
      "description": "Make your family weekend trips special with our spacious and comfortable family trip cabs in Pune. Our vehicles accommodate groups of all sizes with safety and convenience."
    },
    {
      "name": "Weekend Nature Trip Taxi Pune",
      "description": "Escape the city hustle with our Weekend Nature Trip Taxi services in Pune. Explore lush greenery, waterfalls, and serene locations around Pune with our dedicated taxi services."
    },
    {
      "name": "Weekend Hill Station Cab Pune",
      "description": "Enjoy the cool breeze and stunning views with our Weekend Hill Station Cab services from Pune. Our drivers are experienced in hill routes ensuring a smooth and safe journey."
    },
    {
      "name": "Pune Weekend Taxi Deals",
      "description": "Grab exciting Pune Weekend Taxi Deals and discounts on your next weekend getaway. Book now to avail special offers tailored for weekend travelers."
    },
    {
      "name": "Weekend Adventure Trip Cab Pune",
      "description": "Fuel your adrenaline with our Weekend Adventure Trip Cab services in Pune. Perfect for trekking, camping, and adventure sports enthusiasts looking for reliable transport."
    },
    {
      "name": "Pune Weekend Cab with Driver",
      "description": "Relax and enjoy your weekend with our Pune Weekend Cab service with experienced drivers. Professional chauffeurs ensure punctuality, safety, and a hassle-free travel experience."
    },
    {
      "name": "Weekend Holiday Cab Pune",
      "description": "Celebrate your weekends with our Weekend Holiday Cab service in Pune. Ideal for leisure travelers seeking comfort, reliability, and affordability."
    },
    {
      "name": "Pune Weekend Cab Service",
      "description": "Our Pune Weekend Cab Service offers comprehensive travel solutions for all your weekend plans. From quick city trips to outstation adventures, trust us for dependable and affordable cabs."
    }
  ],
  "tableData": [
    ["Weekend Getaway Cab Pune", "Pune Weekend Trip Taxi"],
    ["Weekend Tour Cabs Pune", "Affordable Weekend Getaway Taxi Pune"],
    ["Weekend Trip Taxi Booking Pune", "Weekend Outstation Cab Pune"],
    ["Pune Weekend Cab Packages", "Weekend Family Trip Cab Pune"],
    ["Weekend Nature Trip Taxi Pune", "Weekend Hill Station Cab Pune"],
    ["Pune Weekend Taxi Deals", "Weekend Adventure Trip Cab Pune"],
    ["Pune Weekend Cab with Driver", "Weekend Holiday Cab Pune"],
    ["Pune Weekend Cab Service", "—"]
  ],


     "whychoose": [
    {
      "WhyChooseheading": "Comfortable Weekend Getaway Cabs from Pune",
      "WhyChoosedescription": "Platinum24 Cabs provides hassle-free and cozy cab services for your weekend trips from Pune to nearby destinations."
    },
    {
      "WhyChooseheading": "Ideal for Short Trips and Leisure Travel",
      "WhyChoosedescription": "Perfect for quick escapes to hill stations, beaches, and popular tourist spots around Pune."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "Travel in clean, air-conditioned cabs to ensure a safe and comfortable journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Weekend Routes",
      "WhyChoosedescription": "Our drivers know the best routes and local attractions to enhance your getaway experience."
    },
    {
      "WhyChooseheading": "Flexible Booking for One-Way or Round Trips",
      "WhyChoosedescription": "Choose the package that best suits your weekend itinerary and travel needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
      "WhyChoosedescription": "Enjoy upfront pricing that covers fuel, tolls, and driver allowances for stress-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our dedicated support team is available anytime to assist you with bookings and queries."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options for Solo, Family, or Group Travel",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and comfort preference."
    }
  ]











































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer weekend getaway cab services from Pune?',
        answer: 'Yes, Platinum24 Cabs provides comfortable and reliable weekend getaway cab services from Pune to popular nearby destinations.',
    },
    {
        question: 'What are some popular weekend getaway destinations from Pune covered by your cabs?',
        answer: 'We cover destinations like Lonavala, Khandala, Mahabaleshwar, Panchgani, Malshej Ghat, and more for weekend trips.',
    },
    {
        question: 'How do I book a weekend getaway cab from Pune with Platinum24 Cabs?',
        answer: 'You can book your weekend getaway cab via our website, mobile app, or by contacting our customer support.',
    },
    {
        question: 'What types of vehicles are available for weekend getaway trips?',
        answer: 'We offer sedans, SUVs, tempo travellers, and luxury vehicles suitable for solo travelers, families, and groups.',
    },
    {
        question: 'Are weekend getaway cabs available for round trips?',
        answer: 'Yes, we offer flexible round-trip packages tailored for weekend getaways from Pune.',
    },
    {
        question: 'Can I customize the itinerary for my weekend getaway cab service?',
        answer: 'Absolutely! You can customize your travel itinerary, stops, and timings as per your preferences.',
    },
    {
        question: 'Are the drivers experienced with weekend getaway routes from Pune?',
        answer: 'Yes, our drivers are well-versed with the popular getaway routes and ensure a safe and pleasant journey.',
    },
    {
        question: 'Is advance booking required for weekend getaway cabs?',
        answer: 'We recommend booking in advance, especially during peak seasons and weekends, to guarantee vehicle availability.',
    },
    {
        question: 'Do you provide multi-day rental options for weekend getaways?',
        answer: 'Yes, we offer hourly and multi-day rental packages to suit your weekend travel plans.',
    },
    {
        question: 'Are safety and hygiene maintained during weekend getaway cab rides?',
        answer: 'All our vehicles are regularly sanitized and drivers follow strict safety protocols to keep you safe.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Joshi',
        feedback: 'The weekend getaway cab from Pune was perfect. Comfortable car and friendly driver made the trip enjoyable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Booked a cab for a weekend trip to Lonavala. The service was smooth, punctual, and very professional.',
        rating: 5,
    },
];

















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const weekendGetawayCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable Weekend Getaway Cab service from Pune, ideal for family trips, nature excursions, hill station tours, and weekend adventures.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Weekend Getaway Cab Pune",
    "Pune Weekend Trip Taxi",
    "Weekend Tour Cabs Pune",
    "Affordable Weekend Getaway Taxi Pune",
    "Weekend Trip Taxi Booking Pune",
    "Weekend Outstation Cab Pune",
    "Pune Weekend Cab Packages",
    "Weekend Family Trip Cab Pune",
    "Weekend Nature Trip Taxi Pune",
    "Weekend Hill Station Cab Pune",
    "Pune Weekend Taxi Deals",
    "Weekend Adventure Trip Cab Pune",
    "Pune Weekend Cab with Driver",
    "Weekend Holiday Cab Pune",
    "Pune Weekend Cab Service"
  ]
};







    return (
        <div>
<Helmet>
  <title>Weekend Getaway Cabs from Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable Weekend Getaway Cab service from Pune, ideal for family trips, nature excursions, hill station tours, and weekend adventures."
  />
  <meta
    name="keywords"
    content="Weekend Getaway Cab Pune, Pune Weekend Trip Taxi, Weekend Tour Cabs Pune, Affordable Weekend Getaway Taxi Pune, Weekend Trip Taxi Booking Pune, Weekend Outstation Cab Pune, Pune Weekend Cab Packages, Weekend Family Trip Cab Pune, Weekend Nature Trip Taxi Pune, Weekend Hill Station Cab Pune, Pune Weekend Taxi Deals, Weekend Adventure Trip Cab Pune, Pune Weekend Cab with Driver, Weekend Holiday Cab Pune, Pune Weekend Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(weekendGetawayCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weekendgatwaycabfrom;